import "../styles/bootstrap.min.css";
import "../styles/main.css";
import "../styles/header.css";
import "../styles/element.css";
import "../styles/fontawesome.css";

import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import { AppContext } from "../contexts";
import Alert from "./alert";

const Maintenance = ({ language = "EN" }) => {
  const { showMaintenance, setShowMaintenance } = useContext(AppContext);
  const [showBlock, setShowBlock] = useState(false);
  const [blockData, setBlockData] = useState({});

  const resetShowMaintenance = () => {
    setShowMaintenance({ title: "", message: "" });
  };

  useEffect(() => {
    async function checkMaintenance() {
      try {
        let response;
        try {
          response = await axios.get(process.env.GATSBY_CONFIG_URL);
        } catch (error) {
          response = await axios.get(process.env.GATSBY_CONFIG_URL_2);
        }

        const {
          start = "",
          end = "",
          block_start = "",
          block_end = "",
          block_title = "",
          block_message = "",
          block_mesej = "",
          title: incomingTitle = "[NOTICE] SCHEDULED SYSTEM MAINTENANCE",
          message = "",
          mesej = "",
        } = response?.data?.maintenance?.secureMotor ?? {};

        const now = moment();
        const alertStart = moment(start, "YYYY-MM-DD HH:mm");
        const alertEnd = moment(end, "YYYY-MM-DD HH:mm");
        const blockStart = moment(block_start, "YYYY-MM-DD HH:mm");
        const blockEnd = moment(block_end, "YYYY-MM-DD HH:mm");

        setBlockData({
          title: block_title,
          message: language == "EN" ? block_message : block_mesej,
        });

        if (now.isBetween(alertStart, alertEnd)) {
          setShowMaintenance({
            title: incomingTitle,
            message: language == "EN" ? message : mesej,
          });
        } else {
          resetShowMaintenance();
        }
        setShowBlock(now.isBetween(blockStart, blockEnd));
      } catch (error) {
        console.error("Failed to load config", error);
      }
    }

    checkMaintenance();
    const interval = setInterval(checkMaintenance, 30000);
    return () => clearInterval(interval);
  }, [setShowMaintenance]);

  return (
    <>
      <Alert showAlert={showBlock} data={blockData} />
      <div className="alert-note" hidden={!showMaintenance?.message}>
        <div className="alert-bg">
          <span className="closebtn" onClick={() => resetShowMaintenance()}>
            ×
          </span>
          <i className="fas fa-exclamation-circle"></i>{" "}
          <span className="bold">{showMaintenance?.title} </span>
          <br />
          <div className="row">
            {
              <div className="col-md-12 pad-left pt-1">
                {showMaintenance?.message}
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Maintenance;
